<div
  class="modal-header bg-head py-2 d-flex justify-content-between align-items-center"
>
  <h6 class="modal-title mb-0">Description</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>

<hr class="mt-0" />
<div class="modal-body m-body">
  <editor [(ngModel)]="description" [init]="tinyMceOption"></editor>
</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button type="button" class="bl-btn btn btn-sm px-3" (click)="onSave()">
    Ok
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border px-3"
    (click)="onCross()"
  >
    Cancel
  </button>
</div>
